import COUNTRIES from '../constants/countries';
import SKIN_TYPES from '../constants/skin_types';

export const quizFromBackendToFrontend = (quiz) => ({
  id: quiz.id,
  userId: quiz.user_id,
  step: quiz.current_step,
  category: quiz.category,
  concerns: quiz.solving_problems ? quiz.solving_problems.split(',').map((concern) => concern.trim()) : [],
  solvingProblems: quiz.solving_problems || '',
  texture: quiz.texture,
  firstName: quiz.user_first_name || '',
  lastName: quiz.user_last_name || '',
  age: quiz.user_age_range,
  uniqueIngredient: quiz.any_special_ingredients || '',
  whatMakesItSpecial: quiz.what_makes_it_special || '',
  inspiration: quiz.inspire_story || '',
  howHearAboutUs: quiz.how_hear_about_us || '',
  color: quiz.color,
  country: quiz.country,
  state: quiz.state || '',
  skinType: quiz.skin_type,
  instagramLink: quiz.instagram_link || '',
  facebookLink: quiz.facebook_link || '',
  anythingElse: quiz.special_coverage_type || '',
  productType: quiz.product_type || '',
  files: [],
  application: quiz.application || '',
  lookAndFeel: quiz.look_and_feel || '',
  videoUrl: quiz.video_url || '',
  shades: quiz.shades || '',
});

export const quizFromFrontendToBackend = (quiz) => ({
  id: quiz.id,
  user_id: quiz.userId,
  current_step: quiz.step,
  category: quiz.category,
  solving_problems: quiz.solvingProblems || quiz.concerns.join(', '),
  texture: quiz.texture,
  user_first_name: quiz.firstName,
  user_last_name: quiz.lastName,
  user_age_range: quiz.age,
  any_special_ingredients: quiz.uniqueIngredient,
  what_makes_it_special: quiz.whatMakesItSpecial,
  inspire_story: quiz.inspiration,
  how_hear_about_us: quiz.howHearAboutUs,
  color: quiz.color,
  country: quiz.country || COUNTRIES.USA,
  state: quiz.state,
  skin_type: quiz.skinType || SKIN_TYPES[0],
  instagram_link: quiz.instagramLink,
  facebook_link: quiz.facebookLink,
  special_coverage_type: quiz.anythingElse,
  product_type: quiz.productType,
  files: quiz.files,
  application: quiz.application,
  look_and_feel: quiz.lookAndFeel,
  video_url: quiz.videoUrl,
  shades: quiz.shades,
});
